"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { d: "M14.885 3h-6.77C6.948 3 6 3.916 6 5.045v13.91C6 20.084 6.948 21 8.115 21h6.77C16.052 21 17 20.084 17 18.954V5.045C17 3.916 16.052 3 14.885 3zM11.5 20.182c-.702 0-1.27-.548-1.27-1.227 0-.68.568-1.228 1.27-1.228.702 0 1.27.549 1.27 1.227 0 .68-.568 1.228-1.27 1.228zm3.808-3.273H7.692V5.455h7.616v11.454z" }), "ResolutionSmall");
//# sourceMappingURL=ResolutionSmall.js.map